// Unified client logos data shared across components
export const clientLogos = [
  // 1. GO COMMERCE
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/b21985b1-ea9c-4e77-8da9-ebbc6608b568/06434175-4f1c-4e71-8d56-f224f254face.png?content-type=image%2Fpng",
  
  // 2. NCS
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/d46b9ad7-1d2f-43d4-a024-02bbfe85dd4d/9ddfbc03-ccb1-437a-94dd-9f4d862d2adb.png?content-type=image%2Fpng",
  
  // 3. DBS
  "/lovable-uploads/dbs-logo.svg",
  
  // 4. Unilever
  "/lovable-uploads/6f72231a-02bb-4284-8f6b-be1f16570b92.png",
  
  // 5. MOTUL
  "/lovable-uploads/befabc60-5300-4214-b167-e916f1447aef.png",
  
  // 6. SINGTEL
  "/lovable-uploads/singtel-logo.png",
  
  // 6. Singlife
  "/lovable-uploads/singlife-logo.svg",
  
  // 7. Volvo
  "/lovable-uploads/volvo-logo.svg",
  
  // 8. NTUC
  "/lovable-uploads/ntuc-logo.png",
  
  // 9. IMDA
  "/lovable-uploads/imda-logo.svg",
  
  // 10. DEEM
  "/lovable-uploads/8a04475a-011c-422b-a117-3d3729d73287.png",
  
  // 11. KNIGHT FRANK
  "/lovable-uploads/a736fac8-3234-4821-83ec-c67e969de299.png",
  
  // 12. WEBER Shandwick
  "/lovable-uploads/74da15ff-3ab9-4eee-8b91-1255f3e7ad9b.png",
  
  // 13. CENTURY PACIFIC
  "/lovable-uploads/century-pacific-logo.svg",
  
  // 14. NTU
  "/lovable-uploads/ntu-logo.png",
  
  // 15. IGNYTE
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/6cee356a-106e-4a74-a662-ec970f3dfe61/70188ecd-831e-4576-b8df-a46d7bbf4017.png?content-type=image%2Fpng",
  
  // 14. HL BANK
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/fd033a8e-3a90-4b61-9965-9b4fbb64845d/38621168-1994-4d74-bd94-177eb01c07b6.png?content-type=image%2Fpng",
  
  // 15. AAMS
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/5672ca6d-b86a-4b52-aa5f-acf2ec608de8/4afcd5fc-47e6-4536-b8ef-5413aaaec1c1.png?content-type=image%2Fpng",
  
  // 16. IYRIS
  "/lovable-uploads/iyris-logo.png",
  
  // 17. AMBER COMM
  "https://images.squarespace-cdn.com/content/6712145f4a2aba0c43ebb02d/6d71f99f-5d29-4770-8368-61998621f6b2/277feaaa-9961-4c50-bbf0-d71151e17a5f.png?content-type=image%2Fpng",
  
  // 18. MOGUL WORKS
  "/lovable-uploads/mogul-works-logo.png",
  
  // 19. BRANDVERGE
  "/lovable-uploads/a1de4eef-489a-49b4-9451-239c02b02b79.png",
  
  // 20. RAFFLES
  "/lovable-uploads/raffles-health-insurance-logo.webp",
  
  // 21. IRWIN
  "/lovable-uploads/7d52db30-dc9f-4a7b-b5b6-2bf66a31a72d.png",
  
  // 22. SEK
  "/lovable-uploads/9afc3766-e7c8-4de6-aaba-51d9013aef48.png",
  
  // 23. BEYOND 4
  "/lovable-uploads/e9050f13-f1f3-4701-b206-e8550cea8f75.png",
  
  // 24. STORYTEL
  "/lovable-uploads/735817df-ca08-486a-b573-df2d78bd57ca.png",
  
  // 25. YOUR STORY
  "/lovable-uploads/3b07e49f-f36f-46a0-bfea-92705d474096.png",
  
  // 26. CLARITAS
  "/lovable-uploads/d3ec5ab5-d465-4379-ac1b-cd993acabda7.png"
];
